/// JTF3-added-AB-22-05-12


'use strict'

jQuery(document).ready(function($) {
	$('.mobilemenu__trigger').on('click', function(e) {
		e.preventDefault();
		$(this).toggleClass('mobilemenu__open');
		$('.navigation__menu').toggleClass('navigation__menu--open');
	});

	$('.menu-item-has-children a').on('click', function(e) {
		e.stopPropagation();

		if ($(this).parent().hasClass('menu-item-has-children') && ! $(this).parents().hasClass('sub-menu')) {
			// TOGGLE CHILD MENU
			e.preventDefault();
			$(this).parent().siblings().find('.sub-menu-wrap').removeClass('navigation__child');
			$(this).parent().find('.sub-menu-wrap').first().toggleClass('navigation__child');
			$(this).parent().siblings().removeClass('navigation__parent--open');
			$(this).parent().toggleClass('navigation__parent--open');
			$('.navigation__grandchild').removeClass('navigation__grandchild');
			$('.navigation__child--open').removeClass('navigation__child--open');
		} else if ($(this).parent().hasClass('menu-item-has-children') && $(this).parents().hasClass('sub-menu')) {
			e.preventDefault();
			// TOGGLE GRAND CHILD MENU
			// Find parent, find siblings - close menu of all siblings before toggling state of this menu
			$(this).parent().siblings().find('.sub-menu-wrap').removeClass('navigation__grandchild');
			$(this).parent().find('.sub-menu-wrap').first().toggleClass('navigation__grandchild');
			$(this).parent().siblings().removeClass('navigation__child--open');
			$(this).parent().toggleClass('navigation__child--open');
		} else {
			// Normal link
		}

		// Clear all open menus when user clicks outside of menu
		$('body').on( 'click', function() {
			$('.navigation__parent--open').removeClass('navigation__parent--open');
			$('.navigation__child').removeClass('navigation__child');
			$('.navigation__child--open').removeClass('navigation__child--open');
			$('.navigation__grandchild').removeClass('navigation__grandchild');
		});
	});
});
